import { render, staticRenderFns } from "./DesignerSidebar.vue?vue&type=template&id=10ac5997&scoped=true"
import script from "./DesignerSidebar.vue?vue&type=script&lang=js"
export * from "./DesignerSidebar.vue?vue&type=script&lang=js"
import style0 from "./DesignerSidebar.vue?vue&type=style&index=0&id=10ac5997&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac5997",
  null
  
)

export default component.exports